(function(){
  const dataEl = document.getElementById('renegade-flavors-json');
  if (!dataEl) return;
  const flavors = JSON.parse(dataEl.textContent || '[]');
  window.themeAssetsBase = window.themeAssetsBase || document.querySelector('.brand img')?.src.replace('renegade-logo-lockup.png','') || '/cdn/shop/t/0/assets/';
  const selected = [];
  const track = (eventType, flavor, slotIndex) => {
    try {
      const key = 'renegade_flavor_session';
      let sessionId = localStorage.getItem(key);
      if (!sessionId) { sessionId = crypto.randomUUID(); localStorage.setItem(key, sessionId); }
      const payload = JSON.stringify({ eventType, flavor, slotIndex, selectedFlavors: selected.map((item) => item.title || item), sessionId, pagePath: location.pathname + location.search + location.hash });
      const endpoint = window.renegadeFlavorEventsEndpoint || 'https://renegade-energy-shots.loupereira74.chatgpt.site/api/flavor-events';
      if (navigator.sendBeacon) {
        navigator.sendBeacon(endpoint, new Blob([payload], { type: 'text/plain' }));
        return;
      }
      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: payload, keepalive: true, mode: 'cors' }).catch(() => undefined);
    } catch(e) {}
  };
  const imgUrl = (name) => `${window.themeAssetsBase}${name}`;
  const functionsDataEl = document.getElementById('renegade-functions-json');
  const functionShots = functionsDataEl ? JSON.parse(functionsDataEl.textContent || '[]') : [];
  const functionBottom = [
    ['200 mg CAFFEINE', ''],
    ['1000 mg SODIUM<br>200 mg POTASSIUM<br>60 mg MAGNESIUM', ''],
    ['250 mg Citicoline<br>200 mg L-Theanine<br>B6 + B12', ''],
    ['400 mg Nitrate<br>1600 mg β-Alanine<br>1250 mg Betaine<br>150 mg Sodium<br>100 mg Potassium', ''],
    ['500 mg Tart Cherry<br>250 mg Sodium<br>200 mg Potassium<br>60 mg Magnesium', ''],
    ['200 mg L-Theanine<br>1 mg Melatonin<br>60 mg Magnesium', '']
  ];
  const functionHeroContent = {
    default: {
      artKey: 'defaultImage',
      tag: 'Renegade functional shots',
      title: ['One shot.', 'One purpose.', 'Six functions.'],
      subtitle: 'Six functions. One pocket-ready 1 oz format.',
      cta: 'Explore The Lineup',
      secondary: 'Compare Functions',
      features: [
        ['Six<br>Functions', 'Energy, hydration,<br>focus, and more.'],
        ['1 oz<br>Format', 'Pocket-ready<br>daily support.'],
        ['Purpose<br>Built', 'Pick the shot<br>for the mission.']
      ],
      bottom: functionBottom,
      panel: {
        heading: ['One format', 'six functions'],
        cards: [
          ['Energy + Hydration', ['Power up', 'Reload fast', 'Carry less']],
          ['Focus + Performance', ['Lock in', 'Train hard', 'Keep moving']],
          ['Recovery + Sleep', ['Reset', 'Wind down', 'Recover better']]
        ]
      }
    },
    energy: {
      artKey: 'energyImage',
      tag: '',
      title: ['Ditch the can.', 'Take the shot.', ''],
      subtitle: '200 MG CAFFEINE|LESS DRINK. MORE DO.',
      cta: 'Shop Energy Shot',
      ctaUrl: '/pages/energy',
      secondary: 'View Ingredients',
      features: [
        ['200 MG<br>Caffeine', 'Power you can<br>feel fast.'],
        ['Real<br>Sugar', 'All energy.<br>No fake BS.'],
        ['Pocket<br>Ready', 'Go anywhere.<br>Do anything.']
      ],
      bottom: functionBottom,
      panel: null
    },
    energyTubes: {
      artKey: 'energyTubesImage',
      tag: '',
      title: ['Energy.', 'Anytime.', 'Anywhere.'],
      subtitle: '100 MG CAFFEINE|TWIST. SHOOT. GO.',
      cta: 'Shop Energy Tube',
      ctaUrl: '/pages/energy-tubes',
      secondary: '',
      features: [
        ['100 MG<br>Caffeine', 'Pocket-ready<br>energy.'],
        ['0.20 OZ<br>Tube', 'Small format.<br>Fast routine.'],
        ['Twist.<br>Shoot. Go.', 'Carry less.<br>Keep moving.']
      ],
      bottom: functionBottom,
      panel: null
    },
    hydration: {
      artKey: 'hydrationImage',
      tag: '',
      title: ['Ditch the bottle.', 'Take the shot.', ''],
      subtitle: '1000 MG SODIUM|200 MG POTASSIUM|60 MG MAGNESIUM|LESS DRINK. MORE DO.',
      cta: 'Shop Hydration',
      ctaUrl: '/pages/hydration',
      secondary: 'View Ingredients',
      features: [
        ['Electrolytes', 'Hydration support<br>when you need it.'],
        ['Real<br>Sugar', '2g real cane sugar.<br>No fake BS.'],
        ['Pocket<br>Ready', 'Small shot.<br>Big impact.']
      ],
      bottom: functionBottom,
      panel: {
        heading: ['Hydration support', 'built to <em>reload.</em>'],
        cards: [
          ['Electrolytes', ['Replenish what you lose.', 'Hydration support', 'Daily reload']],
          ['Sodium', ['Fluid balance', 'Electrolyte support', 'Built for sweat']],
          ['Potassium', ['Muscle function', 'Mineral support', 'Keep moving']],
          ['Magnesium', ['Mineral support', 'Performance support', 'No full can']]
        ]
      }
    },
    focus: {
      artKey: 'focusImage',
      tag: '',
      title: ['Cut the noise.', 'Take the shot.', ''],
      subtitle: '250 MG Citicoline|200 MG L-Theanine|B6 + B12|LESS DRINK. MORE DO.',
      cta: 'Shop Focus',
      ctaUrl: '/pages/focus',
      secondary: '',
      features: [
        ['250mg<br>Citicoline', 'Focus support<br>that stays clean.'],
        ['200 MG<br>L-Theanine', 'Smooth focus.<br>No fake BS.'],
        ['Pocket<br>Ready', 'Lock in.<br>Keep moving.']
      ],
      bottom: functionBottom,
      panel: null
    },
    performance: {
      artKey: 'performanceImage',
      tag: '',
      title: ['Ditch the mix.', 'Take the shot.', ''],
      subtitle: '400 MG NITRATE|1600 MG β-Alanine|1250 MG BETAINE|150 MG SODIUM|100 MG POTASSIUM|LESS DRINK. MORE DO.',
      cta: 'Shop Performance',
      ctaUrl: '/pages/performance',
      secondary: '',
      features: [
        ['400mg<br>Nitrate', 'Performance support<br>that hits clean.'],
        ['1,600mg<br>Beta-Alanine', 'Train hard.<br>Push further.'],
        ['1250mg<br>Betaine', 'Built for output.<br>No full scoop.']
      ],
      bottom: functionBottom,
      panel: null
    },
    recovery: {
      artKey: 'recoveryImage',
      tag: '',
      title: ['Ditch the scoop.', 'Take the shot.', ''],
      subtitle: '500 MG TART CHERRY|250 MG SODIUM|200 MG POTASSIUM|60 MG MAGNESIUM|LESS DRINK. MORE DO.',
      cta: 'Shop Recovery',
      ctaUrl: '/pages/recovery',
      secondary: '',
      features: [
        ['500mg<br>Tart Cherry', 'Recovery support<br>after the work.'],
        ['Electrolytes', 'Reload what<br>training takes.'],
        ['Pocket<br>Ready', 'Reset fast.<br>Keep moving.']
      ],
      bottom: functionBottom,
      panel: null
    },
    sleep: {
      artKey: 'sleepImage',
      tag: '',
      title: ['Shut it down.', 'Take the shot.', ''],
      subtitle: '200 MG L-THEANINE|1 MG MELATONIN|60 MG MAGNESIUM|LESS DRINK. MORE DO.',
      cta: 'Shop Sleep',
      ctaUrl: '/pages/sleep',
      secondary: '',
      features: [],
      bottom: functionBottom,
      panel: null
    }
  };
  const storeHeroDefaults = (stage) => {
    if (!stage || stage.dataset.heroDefaultsStored) return;
    const panelCards = stage.querySelector('[data-panel-cards]');
    stage.dataset.panelDefault = panelCards ? panelCards.innerHTML : '';
    const panelHeading = stage.querySelector('[data-panel-heading]');
    stage.dataset.panelHeadingDefault = panelHeading ? panelHeading.innerHTML : '';
    stage.dataset.heroDefaultsStored = 'true';
  };
  const setHeroContent = (hero, shot) => {
    const stage = hero.matches('[data-hero-stage]') ? hero : hero.querySelector('[data-hero-stage]');
    if (!stage) return;
    storeHeroDefaults(stage);
    const content = functionHeroContent[shot.key] || {
      ...functionHeroContent.energy,
      artKey: `${shot.key}Image`,
      tag: shot.title || shot.key,
      title: shot.headline ? shot.headline.split('. ').slice(0, 3).map((line, index, lines) => index < lines.length - 1 ? `${line}.` : line) : functionHeroContent.energy.title,
      subtitle: shot.copy || functionHeroContent.energy.subtitle,
      cta: shot.cta || `Shop ${shot.title || 'Shot'}`
    };
    if (shot.key === 'default') {
      stage.dataset.defaultHero = 'true';
    } else {
      delete stage.dataset.defaultHero;
    }
    stage.dataset.activeFunction = shot.key;
    const art = stage.querySelector('[data-hero-art]');
    if (art) {
      const image = art.dataset[content.artKey] || art.dataset.energyImage || art.dataset.defaultImage;
      art.style.backgroundImage = shot.key === 'energy' || shot.key === 'energyTubes' || shot.key === 'focus' || shot.key === 'performance' || shot.key === 'recovery' || shot.key === 'sleep'
        ? `url('${image}')`
        : `linear-gradient(90deg, rgba(0,0,0,.98) 0%, rgba(0,0,0,.72) 28%, rgba(0,0,0,.1) 54%, rgba(0,0,0,.72) 78%, rgba(0,0,0,.98) 100%), url('${image}')`;
    }
    const tag = stage.querySelector('[data-hero-tag]');
    if (tag) tag.textContent = content.tag;
    content.title.forEach((line, index) => {
      const el = stage.querySelector(`[data-hero-title-line="${index + 1}"]`);
      if (!el) return;
      el.textContent = line;
      el.hidden = !line;
    });
    const subtitle = stage.querySelector('[data-hero-subtitle]');
    if (subtitle) {
      const lines = (content.subtitle || '').split('|').filter(Boolean);
      const tagline = lines[lines.length - 1] || '';
      if (lines.length > 1 && tagline.toUpperCase() === 'LESS DRINK. MORE DO.') {
        subtitle.dataset.hasTagline = 'true';
        const ingredientLines = lines.slice(0, -1);
        subtitle.replaceChildren();
        ingredientLines.forEach((line) => {
          const lineEl = document.createElement('span');
          lineEl.textContent = line;
          subtitle.append(lineEl);
        });
        const taglineEl = document.createElement('strong');
        taglineEl.textContent = tagline;
        subtitle.append(taglineEl);
      } else {
        delete subtitle.dataset.hasTagline;
        subtitle.textContent = (content.subtitle || '').replaceAll('|', '\n');
      }
    }
    const cta = stage.querySelector('[data-hero-cta]');
    if (cta) {
      cta.dataset.defaultHref = cta.dataset.defaultHref || cta.getAttribute('href') || '';
      cta.textContent = content.cta;
      cta.href = content.ctaUrl || cta.dataset.defaultHref;
    }
    const secondary = stage.querySelector('[data-hero-secondary]');
    if (secondary) {
      secondary.dataset.defaultHref = secondary.dataset.defaultHref || secondary.getAttribute('href') || '';
      secondary.textContent = content.secondary;
      secondary.href = content.secondaryUrl || secondary.dataset.defaultHref;
    }
    const features = stage.querySelectorAll('[data-feature-item]');
    features.forEach((feature, index) => {
      const item = content.features[index];
      if (!item) return;
      const title = feature.querySelector('[data-feature-title]');
      const copy = feature.querySelector('[data-feature-copy]');
      if (title) title.innerHTML = item[0];
      if (copy) copy.innerHTML = item[1];
    });
    const bottomItems = content.bottom && content.bottom.length === stage.querySelectorAll('[data-bottom-item]').length ? content.bottom : functionBottom;
    stage.querySelectorAll('[data-bottom-item]').forEach((itemEl, index) => {
      const item = bottomItems[index];
      if (!item) return;
      const title = itemEl.querySelector('[data-bottom-title]');
      const copy = itemEl.querySelector('[data-bottom-copy]');
      if (title) title.innerHTML = item[0];
      if (copy) copy.innerHTML = item[1];
    });
    const panelCards = stage.querySelector('[data-panel-cards]');
    const panelHeading = stage.querySelector('[data-panel-heading]');
    if (panelCards && panelHeading) {
      if (!content.panel) {
        panelHeading.innerHTML = stage.dataset.panelHeadingDefault || panelHeading.innerHTML;
        panelCards.innerHTML = stage.dataset.panelDefault || panelCards.innerHTML;
      } else {
        panelHeading.innerHTML = `<span>${content.panel.heading[0]}</span><strong>${content.panel.heading[1]}</strong>`;
        panelCards.innerHTML = content.panel.cards.map((card) => `<article class="comparison-card comparison-card-ingredient"><div><h2>${card[0]}</h2><ul>${card[1].map((item) => `<li>${item}</li>`).join('')}</ul></div></article>`).join('');
      }
    }
  };
  const setHeroMenu = (hero, shot) => {
    if (!hero || !shot) return;
    hero.style.setProperty('--function-accent', shot.accent || '#ed0808');
    hero.querySelectorAll('[data-function-tab]').forEach((tab) => {
      const active = tab.dataset.functionTab === shot.key;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    hero.querySelectorAll('[data-special-hero]').forEach((button) => {
      const active = button.dataset.specialHero === shot.key;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    hero.classList.toggle('has-energy-subnav', shot.key === 'energy');
    setHeroContent(hero, shot);
  };
  const setHeroDefault = (hero) => {
    if (!hero) return;
    hero.style.setProperty('--function-accent', '#ed0808');
    hero.querySelectorAll('[data-function-tab]').forEach((tab) => {
      tab.classList.remove('is-active');
      tab.setAttribute('aria-selected', 'false');
    });
    hero.querySelectorAll('[data-special-hero]').forEach((button) => {
      button.classList.remove('is-active');
      button.setAttribute('aria-pressed', 'false');
    });
    hero.classList.remove('has-energy-subnav');
    const stage = hero.querySelector('[data-hero-stage]');
    if (stage) delete stage.dataset.activeFunction;
    setHeroContent(hero, { key: 'default', title: 'Renegade' });
    if (stage) delete stage.dataset.activeFunction;
    const art = stage ? stage.querySelector('[data-hero-art]') : null;
    if (art && art.dataset.defaultImage) {
      art.style.backgroundImage = `linear-gradient(90deg, rgba(0,0,0,.12) 0%, rgba(0,0,0,0) 14%, rgba(0,0,0,0) 86%, rgba(0,0,0,.12) 100%), url('${art.dataset.defaultImage}')`;
    }
  };
  if (functionShots.length) {
    document.querySelectorAll('[data-hero-menu]').forEach((hero) => {
      hero.querySelectorAll('[data-function-tab]').forEach((tab) => {
        tab.setAttribute('role', 'tab');
        tab.addEventListener('click', () => {
          const shot = functionShots.find((item) => item.key === tab.dataset.functionTab);
          setHeroMenu(hero, shot);
        });
      });
      hero.querySelectorAll('[data-bottle-target]').forEach((button) => {
        button.addEventListener('click', () => {
          const key = button.dataset.bottleTarget;
          const tab = hero.querySelector(`[data-function-tab="${key}"]`);
          if (tab) {
            tab.click();
            if (window.history && window.history.replaceState) {
              window.history.replaceState(null, '', `#${key}`);
            }
          }
        });
      });
      hero.querySelectorAll('[data-special-hero]').forEach((button) => {
        button.addEventListener('click', () => {
          const content = functionHeroContent[button.dataset.specialHero];
          if (!content) return;
          setHeroMenu(hero, { key: button.dataset.specialHero, title: button.textContent.trim(), accent: '#ed0808' });
          if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', '#energy-tubes');
          }
        });
      });
      hero.querySelectorAll('[data-bottom-target]').forEach((column) => {
        const activateColumn = () => {
          const key = column.dataset.bottomTarget;
          const tab = hero.querySelector(`[data-function-tab="${key}"]`);
          if (tab) {
            tab.click();
            if (window.history && window.history.replaceState) {
              window.history.replaceState(null, '', `#${key}`);
            }
          }
        };
        column.addEventListener('click', activateColumn);
        column.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          activateColumn();
        });
      });
      if (hero.classList.contains('mobile-hero')) {
        setHeroMenu(hero, functionShots.find((item) => item.key === 'energy'));
      } else {
        setHeroDefault(hero);
      }
    });
  }
  document.querySelectorAll('.flavor-track').forEach((trackEl) => {
    const isMobileFlavorRow = !!trackEl.closest('.mobile-flavor-carousel-section');
    const rowFlavors = flavors.length <= 6 ? flavors : (isMobileFlavorRow ? flavors.slice(0, 8) : [...flavors, ...flavors]);
    rowFlavors.forEach((flavor, index) => {
      const card = document.createElement('article');
      card.className = 'flavor-slide';
      card.innerHTML = `<img src="${imgUrl(flavor.image)}" alt="${isMobileFlavorRow || index < flavors.length ? flavor.title + ' Renegade functional shot bottle' : ''}" loading="lazy"><h3>${flavor.title}</h3>`;
      trackEl.appendChild(card);
    });
  });
  const mobileFlavorGrid = document.querySelector('.mobile-flavor-grid');
  const mobileFlavorToggle = document.querySelector('.mobile-flavor-toggle');
  if (mobileFlavorGrid && mobileFlavorToggle) {
    flavors.forEach((flavor) => {
      const card = document.createElement('article');
      card.className = 'mobile-flavor-grid-card';
      card.innerHTML = `<img src="${imgUrl(flavor.image)}" alt="${flavor.title} Renegade functional shot bottle" loading="lazy"><h3>${flavor.title}</h3>`;
      mobileFlavorGrid.appendChild(card);
    });
    mobileFlavorToggle.addEventListener('click', () => {
      const expanded = mobileFlavorToggle.getAttribute('aria-expanded') === 'true';
      mobileFlavorToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      mobileFlavorGrid.hidden = expanded;
      mobileFlavorToggle.textContent = expanded ? 'View all 6 shots' : 'Show fewer shots';
    });
  }
  const builder = document.querySelector('.builder');
  if (!builder) return;
  const slotsEl = builder.querySelector('[data-slots]');
  const pickerEl = builder.querySelector('[data-picker]');
  const countEl = builder.querySelector('[data-count]');
  const statusEl = builder.querySelector('[data-status]');
  const addBtn = builder.querySelector('[data-add-pack]');
  const variantId = builder.dataset.productId;
  const isFunctionBuilder = builder.dataset.builderKind === 'function';
  function render(){
    slotsEl.innerHTML = '';
    for (let i=0;i<6;i++) {
      const flavor = selected[i];
      const button = document.createElement('button');
      button.type = 'button';
      button.className = flavor ? 'slot filled' : 'slot';
      button.innerHTML = flavor ? `<img src="${imgUrl(flavor.image)}" alt="" loading="lazy"><span>${flavor.title}</span>` : `<span>Slot ${i+1}</span>`;
      button.addEventListener('click', () => { if (flavor) { selected.splice(i,1); track('flavor_remove', flavor.title, i); render(); } });
      slotsEl.appendChild(button);
    }
    countEl.textContent = `${selected.length}/6`;
    const ready = selected.length === 6 && variantId;
    statusEl.textContent = selected.length === 6 ? 'Pack ready' : (isFunctionBuilder ? 'Select shots' : 'Select flavors');
    addBtn.disabled = !ready;
    addBtn.classList.toggle('ready', !!ready);
    addBtn.textContent = variantId ? (ready ? 'Add 6-pack - $5' : `${6-selected.length} ${isFunctionBuilder ? 'shots' : 'flavors'} left`) : 'Connect Shopify product';
    pickerEl.querySelectorAll('button').forEach((button) => {
      const alreadySelected = isFunctionBuilder && selected.some((item) => item.title === button.dataset.title);
      button.disabled = selected.length >= 6 || alreadySelected;
    });
  }
  flavors.forEach((flavor) => {
    const card = document.createElement('article');
    card.className = 'pick-card';
    card.innerHTML = `<img src="${imgUrl(flavor.image)}" alt="${flavor.title} Renegade ${isFunctionBuilder ? 'Citrus function shot' : 'functional shot bottle'}" loading="lazy"><div><h3>${flavor.title}</h3><button type="button" data-title="${flavor.title}">Add ${isFunctionBuilder ? 'shot' : 'flavor'}</button></div>`;
    card.querySelector('img').addEventListener('click', () => track('flavor_card_click', flavor.title));
    card.querySelector('button').addEventListener('click', () => {
      if (selected.length >= 6) return;
      if (isFunctionBuilder && selected.some((item) => item.title === flavor.title)) return;
      selected.push(flavor);
      track(isFunctionBuilder ? 'shot_add' : 'flavor_add', flavor.title, selected.length - 1);
      render();
    });
    pickerEl.appendChild(card);
  });
  addBtn.addEventListener('click', async () => {
    if (selected.length !== 6 || !variantId) return;
    track('checkout_attempt', isFunctionBuilder ? 'Citrus Function 6-Pack' : 'Renegade Function 6-Pack');
    const originalText = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';
    const properties = {};
    if (isFunctionBuilder) properties['Signature Flavor'] = 'Citrus';
    selected.forEach((flavor, i) => properties[`${isFunctionBuilder ? 'Shot' : 'Flavor'} ${i+1}`] = flavor.title);
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: Number(variantId), quantity: 1, properties }) });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Cart is not ready');
      }
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } catch (error) {
      addBtn.disabled = false;
      addBtn.textContent = error.message || originalText;
      setTimeout(() => { addBtn.textContent = originalText; }, 3500);
    }
  });
  render();
})();
